import React from "react";
import capitalize from "lodash/capitalize";
import isEmpty from "lodash/isEmpty";
import moment from "moment";
import ToggleLinksInput from "../../../../parts/inputs/toggle-links-input";
import NutritionSummary from "../../../athlete-portal/nutrition/components/NutritionSummary";
import Chart from "../../../../parts/chart";
import VolumeHistoryChart from "./VolumeHistoryChart";
import MuscleDiagramCard from "./MuscleDiagramCard";
import EmptyStatementMsg from "./EmptyStatementMsg";
import PersonalRecordsCard from "./PersonalRecordsCard";

// Constants
import { ZONES, DATE_FORMATS, WEIGHT_UNITS } from "../../../../constants";
import { getActiveDayStats } from "../../../../utils/daily-stats";
import {
  convertAndFormatRecordWeights,
  convertOutcomeE1rmAndLoads,
  getWorkloadDistributionData,
} from "../../../../utils/workout-stats";

function QuickMetrics({ locals }) {
  const {
    query,
    dailyStats,
    dayPersonalRecords,
    currentYearExercises,
    activeUser: { isCoachEditing },
  } = locals;

  const { units, date } = query;

  // Nutrition Data

  const activeDayUtc = Number(
    moment(date, DATE_FORMATS.DATE_DAY_FORMAT).format(DATE_FORMATS.UTC)
  );

  const activeDayStats = getActiveDayStats({ activeDayUtc, stats: dailyStats });
  const nutritionPlans = locals.nutritionPlans || [];

  // personal records data
  let PRData = {};
  if (dayPersonalRecords) {
    PRData = convertAndFormatRecordWeights(dayPersonalRecords, units);
  }

  // workload distribution data
  const exercisesConverted =
    units === "imperial"
      ? convertOutcomeE1rmAndLoads(locals.activeExercises)
      : locals.activeExercises;

  const [labels, workloadData] =
    getWorkloadDistributionData(exercisesConverted);
  const workloadDistributionData = [
    {
      name: "workoload-distribution",
      className: "",
      data: workloadData,
    },
  ];

  return (
    <section className="quick-metrics-wrapper">
      <div key={query.date} className={`Quick-Metrics Stats`}>
        <h4 className="alt">Workout Stats</h4>
        <div className="wrapper">
          <div
            className="card volume-chart Chart-Frame bar-chart"
            data-chart="total-volume"
          >
            <div className="flex justify-between items-center mb-4">
              <p className="s1">Last 7 days volume</p>
              <div className="group">
                <ToggleLinksInput
                  name="units"
                  options={[
                    { text: "Kg", value: "metric" },
                    { text: "Lbs", value: "imperial" },
                  ]}
                />
              </div>
            </div>
            <VolumeHistoryChart
              date={date}
              activeDayUtc={activeDayUtc}
              exercises={currentYearExercises}
              units={units}
              height="200px"
              daysBack={7}
            />
          </div>
          <MuscleDiagramCard />
        </div>
        <div className="wrapper">
          {!!dayPersonalRecords && (
            <PersonalRecordsCard
              PRData={PRData}
              units={capitalize(WEIGHT_UNITS[units])}
            />
          )}
          <div className="card workload-distribution Chart-Frame horizontal">
            <p className="s1 mb-4">Workload Distribution</p>
            {isEmpty(workloadDistributionData[0].data) ? (
              <EmptyStatementMsg message="No data to show" />
            ) : (
              <div className="workload-chart">
                <Chart
                  type="Bar"
                  data={{ labels: labels, series: workloadDistributionData }}
                  options={{
                    seriesBarDistance: 40,
                    horizontalBars: true,
                    axisX: { showGrid: false, onlyInteger: true },
                    axisY: { onlyInteger: true, offset: 80 },
                  }}
                  tooltip={(item, i) => {
                    const dataLength = workloadDistributionData[0].data.length;
                    const val =
                      workloadDistributionData[0].data[dataLength - 1 - i];
                    return (
                      <div className="tooltip" style={{ bottom: item.y + 70 }}>
                        <div className="details">
                          <div>
                            <b>{val} sets</b>
                          </div>
                          <div></div>
                        </div>
                      </div>
                    );
                  }}
                />
                <div className="chart-hint-text">
                  * Volume uses total set as a proxy
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="Quick-Metrics Nutrition">
        <h4>Nutrition Section</h4>
        <NutritionSummary
          activeDayUtc={activeDayUtc}
          dayStats={activeDayStats?.nutrients ? activeDayStats : null}
          displayDate={false}
          showNutritionAlways={true}
          nutrientsChartHeight={280}
          nutritionPlans={nutritionPlans}
          withToggle
          isCalendar
        />
      </div>
    </section>
  );
}

export default QuickMetrics;
